(() => {
  const drawer = document.getElementById('ps-cart-drawer');
  const cartType = document.body?.dataset?.cartType || 'drawer';
  const configEl = document.getElementById('ps-cart-drawer-config');
  const config = configEl ? JSON.parse(configEl.textContent) : {};
  if (!drawer) return; // Cart type = page: no drawer markup (card + quick-view adds are handled by ps-card-cart.js)
  const threshold = Number(drawer.dataset.freeDeliveryThreshold || 99900);
  const deliveryMsg = drawer.dataset.freeDeliveryMessage || 'Free delivery on orders over ₹999';

  const itemsEl = document.getElementById('ps-cart-drawer-items');
  const emptyEl = document.getElementById('ps-cart-drawer-empty');
  const totalEl = document.getElementById('ps-cart-drawer-total');
  const deliveryWrap = document.getElementById('ps-cart-delivery');
  const deliveryText = document.getElementById('ps-cart-delivery-text');
  const deliveryFill = document.getElementById('ps-cart-delivery-fill');
  const discountWrap = document.getElementById('ps-cart-discount-form');
  const discountInput = document.getElementById('ps-cart-discount-input');
  const discountApply = document.getElementById('ps-cart-discount-apply');
  const discountMsg = document.getElementById('ps-cart-discount-msg');
  const checkoutBtn = document.getElementById('ps-cart-checkout');
  const upsellEl = document.getElementById('ps-cart-drawer-upsell');

  const money = (cents) => {
    const amount = Number(cents) / 100;
    return `₹${amount.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  };

  const updateCount = (count) => {
    document.querySelectorAll('[data-ps-cart-count]').forEach((el) => {
      el.textContent = count;
    });
    document.querySelectorAll('[data-ps-cart-open]').forEach((trigger) => {
      trigger.setAttribute('aria-label', `Open cart, ${count} items`);
    });
  };

  const applyDiscount = () => {
    const code = discountInput?.value.trim();
    if (!code) {
      discountInput?.focus();
      return;
    }
    const returnTo = window.location.pathname + window.location.search;
    if (discountApply) {
      discountApply.disabled = true;
      discountApply.textContent = 'Applying…';
    }
    window.location.href = `/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(returnTo)}`;
  };

  const renderItems = (cart) => {
    if (!itemsEl) return;
    itemsEl.innerHTML = '';
    if (!cart.items.length) {
      emptyEl?.removeAttribute('hidden');
      itemsEl.setAttribute('hidden', '');
    } else {
      emptyEl?.setAttribute('hidden', '');
      itemsEl.removeAttribute('hidden');
      cart.items.forEach((item) => {
        const row = document.createElement('div');
        row.className = 'ps-cart-drawer__item';
        row.innerHTML = `
          <a class="ps-cart-drawer__item-media" href="${item.url}">
            <img src="${item.image}" alt="${item.title}" width="72" height="72" loading="lazy">
          </a>
          <div class="ps-cart-drawer__item-info">
            <a class="ps-cart-drawer__item-title" href="${item.url}">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="ps-cart-drawer__item-variant">${item.variant_title}</p>` : ''}
            <div class="ps-cart-drawer__item-qty">
              <button type="button" data-ps-qty-change="${item.key}" data-delta="-1" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-ps-qty-change="${item.key}" data-delta="1" aria-label="Increase quantity">+</button>
            </div>
          </div>
          <div class="ps-cart-drawer__item-price">
            <strong>${money(item.final_line_price)}</strong>
            <button type="button" class="ps-cart-drawer__item-remove" data-ps-remove="${item.key}" aria-label="Remove item">×</button>
          </div>
        `;
        itemsEl.appendChild(row);
      });
    }

    if (totalEl) totalEl.textContent = money(cart.total_price);
    if (checkoutBtn) checkoutBtn.href = '/checkout';

    const inCartIds = new Set(cart.items.map((i) => String(i.variant_id)));
    upsellEl?.querySelectorAll('[data-upsell-variant]').forEach((card) => {
      const id = card.dataset.upsellVariant;
      card.hidden = inCartIds.has(id);
    });

    updateDelivery(cart.total_price);
    updateCount(cart.item_count);

    if (cart.cart_level_discount_applications?.length) {
      discountMsg?.removeAttribute('hidden');
      if (discountMsg) {
        discountMsg.textContent = `Applied: ${cart.cart_level_discount_applications.map((d) => d.title).join(', ')}`;
        discountMsg.className = 'ps-cart-drawer__discount-msg is-success';
      }
    }
  };

  const updateDelivery = (totalCents) => {
    if (!deliveryWrap || !deliveryText || !deliveryFill) return;
    deliveryWrap.removeAttribute('hidden');
    const remaining = Math.max(0, threshold - totalCents);
    const progress = Math.min(100, (totalCents / threshold) * 100);
    deliveryFill.style.width = `${progress}%`;
    if (remaining <= 0) {
      deliveryText.textContent = "You've unlocked free delivery!";
      deliveryWrap.classList.add('is-complete');
    } else {
      deliveryText.textContent = `${money(remaining)} away from free delivery · ${deliveryMsg}`;
      deliveryWrap.classList.remove('is-complete');
    }
  };

  const refresh = async () => {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderItems(cart);
    return cart;
  };

  const add = async (variantId, quantity = 1) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: Number(quantity) || 1 }),
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await refresh();
    open();
    return res.json();
  };

  const changeQty = async (key, quantity) => {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    await refresh();
  };

  const open = () => {
    if (cartType === 'page' || !drawer) {
      window.location.href = config.cartUrl || '/cart';
      return;
    }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ps-cart-drawer-open');
    drawer.querySelector('.ps-cart-drawer__close')?.focus();
  };

  const close = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ps-cart-drawer-open');
  };

  drawer?.addEventListener('click', (event) => {
    const closeBtn = event.target.closest('[data-ps-cart-close]');
    if (closeBtn) {
      event.preventDefault();
      close();
    }

    const qtyBtn = event.target.closest('[data-ps-qty-change]');
    if (qtyBtn) {
      const key = qtyBtn.dataset.psQtyChange;
      const delta = Number(qtyBtn.dataset.delta);
      const qtySpan = qtyBtn.parentElement?.querySelector('span');
      const current = Number(qtySpan?.textContent || 1);
      changeQty(key, Math.max(0, current + delta));
    }

    const removeBtn = event.target.closest('[data-ps-remove]');
    if (removeBtn) changeQty(removeBtn.dataset.psRemove, 0);

    const upsellBtn = event.target.closest('[data-ps-upsell-add]');
    if (upsellBtn) {
      add(upsellBtn.dataset.psUpsellAdd, 1);
      upsellBtn.textContent = 'Added ✓';
      setTimeout(() => { upsellBtn.textContent = 'Add +'; }, 1500);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer?.classList.contains('is-open')) close();
  });

  document.querySelectorAll('[data-ps-cart-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      refresh().then(open);
    });
  });

  discountApply?.addEventListener('click', applyDiscount);
  discountInput?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      applyDiscount();
    }
  });

  document.getElementById('ps-product-form')?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const variantId = document.getElementById('ps-variant-id')?.value;
    const qty = document.getElementById('qty')?.value || 1;
    if (!variantId) return;
    const btn = event.target.querySelector('.ps-atc');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    try {
      await add(variantId, qty);
      if (btn) btn.textContent = 'Added ✓';
    } catch {
      if (btn) btn.textContent = 'Try again';
    } finally {
      if (btn) btn.disabled = false;
      setTimeout(() => { if (btn) btn.textContent = 'Add to cart'; }, 2000);
    }
  });

  document.querySelectorAll('.ps-related-card__atc').forEach((button) => {
    button.addEventListener('click', async () => {
      const id = button.dataset.variant;
      if (!id) return;
      await add(id, 1);
      button.classList.add('is-added');
      button.textContent = "It's in ✓";
      setTimeout(() => { button.classList.remove('is-added'); button.textContent = 'Add to cart +'; }, 1600);
    });
  });

  window.PsCart = { open, close, refresh, add };

  refresh();
})();
